import { callProcedure } from 'clickNgo/helpers/api'
import type { IProcedureResponse } from 'clickNgo/models/api'

import { mapMdfActivityFromApi } from '../lib'
import { IMdfActivity } from '../model/types'

import { IMdfActivityApi, IMdfActivityApplyPayload } from './types'

export const applyMdfActivity = async (
  payload: IMdfActivityApplyPayload
): Promise<IMdfActivity> => {
  const response = await callProcedure<IProcedureResponse<IMdfActivityApi[]>>({
    url: '/webservice/621/sp/v4/spJBPMDFActivityApplyChanges/call',
    method: 'POST',
    data: {
      'p.DataJSON': JSON.stringify([payload]),
    },
  })

  if ('error' in response) {
    throw response.error
  }

  const apiData = response.data.Data ?? []
  const [updatedRecord] = apiData.map(mapMdfActivityFromApi)

  return updatedRecord
}
